import flatten from 'lodash.flatten';
import memoize from 'lodash.memoize';
import Fuse from 'fuse.js';
import { translateCity, translateCountry } from './TranslationHelper';
import { differenceInMonths, parse, differenceInDays } from 'date-fns';

const NOW = new Date();

const checkIsNew = (launchDateString: string | null): boolean => {
  if (!!launchDateString) {
    const launchDate = parse(launchDateString, 'yyyy-MM-dd', NOW);
    return differenceInMonths(NOW, launchDate) < 4 && differenceInDays(NOW, launchDate) >= 0;
  }
  return false;
};

export default memoize((locations, places) => {
  const cityResult = locations
    .filter((f, idx, self) => idx === self.findIndex(t => t.area === f.area)) // remove duplicate areas
    .map(({ area, country, isComingSoon, launch_date }) => ({
      country,
      isComingSoon,
      city: area,
      place: null,
      translatedCity: translateCity(area, true),
      translatedCountry: translateCountry(country, true),
      translatedPlace: null,
      isNew: checkIsNew(launch_date),
    }));

  const countryResult = locations
    .filter((f, idx, self) => idx === self.findIndex(t => t.country === f.country)) // remove duplicate countries
    .map(({ country }) => ({
      country,
      city: null,
      place: null,
      translatedCity: null,
      translatedCountry: translateCountry(country, true),
      translatedPlace: null,
      isNew: false
    }));

  const placeResult = places.map(place => ({
    place,
    country: null,
    city: null,
    translatedPlace: place,
    translatedCity: null,
    translatedCountry: null,
    isNew: false
  }));

  const options = {
    shouldSort: true,
    threshold: 0.4,
    caseSensitive: false,
    tokenize: true,
    keys: [
      {
        name: 'city',
        weight: 0.7,
      },
      {
        name: 'place',
        weight: 0.5,
      },
      {
        name: 'country',
        weight: 0.3,
      },
      {
        name: 'translatedCity',
        weight: 0.7,
      },
      {
        name: 'translatedPlace',
        weight: 0.5,
      },
      {
        name: 'translatedCountry',
        weight: 0.3,
      },
    ],
  };

  return new Fuse(flatten([...countryResult, ...cityResult, ...placeResult]), options);
}, (locations, places) => `cities:${locations.length};places:${places.length}`);
